
import { defineComponent } from "vue";

export default defineComponent({
  name: "RadioButton",
  props: {
    label: { type: String, default: "" },
  },
});
